// Pathify
import { make } from 'vuex-pathify'
import _ from 'lodash'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: true,
  hasSales: false,
  salesItems: [
    {
      title: 'Sales Dashboard',
      icon: 'mdi-view-dashboard',
      to: '/SalesDashboard',
    },
  ],
  hasInvoices: false,
  invoiceItems: [

    {
      title: 'Invoice Aging',
      icon: 'mdi-calendar-clock',
      to: '/InvoiceAging',
    },
  ],
  hasSalesTeam: false,
  salesTeamItems: [
    {
      title: 'Sales Team Dashboard',
      icon: 'mdi-view-dashboard',
      to: '/SalesTeamDashboard',
    },
  ],
  hasAllInvoices: false,
  allInvoicesItems: [
    {
      title: 'Team Invoice Aging',
      icon: 'mdi-calendar-clock',
      to: '/TeamInvoiceAging',
    },
  ],
  openSales: [

  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
  addSalesItem: async ({ dispatch, state }, { salesPerson, userId }) => {
    const result = _.find(state.openSales, (os) => os.id === userId)

    if (result === undefined) {
      const newItem =
      {
        id: userId,
        title: `Sales: ${ salesPerson }`,
        icon: 'mdi-view-dashboard-outline',
        to: `/Sales/${ userId }/${ salesPerson }`,
      }

      state.openSales.push(newItem)
    }
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
